import { render, staticRenderFns } from "./banklist.vue?vue&type=template&id=64a05860&"
import script from "./banklist.vue?vue&type=script&lang=js&"
export * from "./banklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports